// @ts-ignore

export var BlendType;
(function (BlendType) {
  BlendType["normal"] = "normal";
  BlendType["additive"] = "additive";
  BlendType["subtractive"] = "subtractive";
  BlendType["min"] = "min";
  BlendType["max"] = "max";
  BlendType["none"] = "none";
})(BlendType || (BlendType = {}));
export var StencilType;
(function (StencilType) {
  StencilType["MULTIPLE"] = "MULTIPLE";
  StencilType["SINGLE"] = "SINGLE";
})(StencilType || (StencilType = {}));
export var MaskOperation;
(function (MaskOperation) {
  MaskOperation["AND"] = "and";
  MaskOperation["OR"] = "or";
})(MaskOperation || (MaskOperation = {}));
export var ILayerStage;
(function (ILayerStage) {
  ILayerStage["INIT"] = "init";
  ILayerStage["UPDATE"] = "update";
})(ILayerStage || (ILayerStage = {}));